import data_ubigeo from "./ubigeo.json";

export let DICCIONARIO_REGIONES_TEXTO_A_CODIGO = {};
export let DICCIONARIO_REGIONES_CODIGO_A_TEXTO = {};
export let DICCIONARIO_REGIONES=[];
export let LISTA_REGIONES = [];
setData();
function setData() {
  if (LISTA_REGIONES.length === 0) {
    DICCIONARIO_REGIONES=data_ubigeo.filter(item => item.id !== "00");
    data_ubigeo.forEach(item => {
      LISTA_REGIONES.push({ value: item.id, label: item.nombre });
      DICCIONARIO_REGIONES_CODIGO_A_TEXTO[item.id] = item.nombre;
      DICCIONARIO_REGIONES_TEXTO_A_CODIGO[encodeURIComponent(item.nombre)] = item.id;
    });
  }
}
